<template>
<div class="box-labourParticulars">
    <div class="nav">
        <router-link to="Manpower"><img src="../../assets/up.png" alt="" class="upClass"></router-link>
        工时制度
        <img src="../../assets/search.png" alt="" class="searchClass" @click="getOnPage">
    </div>
    <!-- 教师上课一卡通打卡 -->
    <div class="swiper-container">
        <div class="swiper-wrapper">
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active" id="title-name-id">教师上课一卡通打卡</h4>
                    <p>1. 考勤周期</p>
                    <span class="spanClass">考勤周期为自然月。</span>
                    <p>2. 一卡通卡片管理</p>
                    <span class="spanClass">教师考勤签到是老师进入教室、记录上课考勤的唯一凭证，二维码名片不能私自发送或借与他人使用，如经发现，将予以没收并视情节轻重予以处罚。</span>
                    <img src="../../assets/1.jpg" alt="" class="QRImgCode-box">
                    <img src="../../assets/xiaNoPage.png" alt="" class="labourParticulars_bottomImg">
                </div>
            </div>
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active" id="title-name-id">教师上课一卡通打卡</h4>
                    <p>3. 打卡制度与规范</p>
                    <span class="spanClass">（1）打卡规范：在班级开课前60分钟之内，教师均可进行考勤签到，超出此范围内均属于异常打卡。教师必须在应上课教学区打卡，否则默认为打卡失败。</span>
                    <span class="spanClass">（2）迟到操作：迟到时间超过40分钟，一卡通将不能正常打卡。教师出现未能正常打卡时，需联系教管员填写《异常考勤处理单》，教师本人根据实际情况勾选未打卡原因并确认签字方可生效，完成后的处理单需交回给教管员。</span>
                    <img src="../../assets/xiaNoPage.png" alt="" class="labourParticulars_bottomImg">
                </div>
            </div>
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active" id="title-name-id">教师上课一卡通打卡</h4>
                    <span class="spanClass">（3）考勤核对：教务管理部将定期对教师考勤情况进行核对和检查，以月度为单位对考勤异常进行汇总，转交至人力资源部。为避免影响课酬的发放，请务必及时确认并回复教务管理部发出的考勤邮件，否则其考勤异常情况将按照制度予以处理。</span>
                    <p>4. 异常考勤豁免</p>
                    <span class="spanClass">（1）异常考勤的豁免权，适用于迟到、早退等考勤异常情况。</span>
                    <span class="spanClass">（2）2次以内（含）的考勤异常，教务管理部将通过邮件与老师确认是否使用豁免权，确认使用则只记录不处罚。</span>
                    <img src="../../assets/xiaNoPage.png" alt="" class="labourParticulars_bottomImg">
                </div>
            </div>
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active" id="title-name-id">教师上课一卡通打卡</h4>
                    <span class="spanClass">（3）2次以上（不含）的考勤异常，教务管理部将通过邮件告知老师已超出豁免权使用次数，将按照考勤制度执行处理。</span>
                    <span class="spanClass">（4）考勤异常豁免权的使用次数按照出现考勤异常的课节数计算。</span>
                    <span class="spanClass">（5）因系统问题导致无法正常打卡，经查证属实则不计入豁免权使用范围。</span>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
export default {
    data() {
        return {
            fingerprintShow: false,
            flowShow: false,
            agreementShow: false
        };
    },
    methods: {
        fn() {
  
        },
        getOnPage() {
            this.$router.push({
                name: 'Search',
                params: {
                    code: "555"
                }
            })
        },
    },
    mounted() {
        this.fn();
        var mySwiper = new Swiper(".swiper-container", {
            direction: "vertical" // 垂直切换选项
            // loop: true // 循环模式选项
        });
    }
};
</script>

<style>
.swiper-container {
    width: 100%;
    height: 100%;
}

.box-labourParticulars {
    width: 100%;
    height: 100%;
    background: rgba(244, 244, 244, 1);
    overflow: hidden;
}

.nav {
    width: 100%;
    height: 50px;
    background: #11a093;
    text-align: center;
    line-height: 50px;
    color: #ffffff;
    position: relative;
    margin-bottom: 17px;
}

.upClass,
.searchClass {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
}

.upClass {
    width: 12px;
    float: left;
    left: 10px;
}

.searchClass {
    width: 19px;
    float: right;
    right: 10px;
}

.labourParticulars {
    width: 90%;
    height: 83%;
    margin: 0 auto;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 12px 0px rgba(136, 135, 135, 0.5);
    border-radius: 11px;
    padding-top: 5%;
    position: relative;
}

.labourParticulars .labourParticulars-title {
    text-align: center;
    font-weight: 600;
}

.labourParticulars .labourParticulars-hw {
    margin-bottom: 20px;
}

.labourParticulars p {
    color: #696969;
    font-size: 16px;
    margin: 25px 16px 0;
}

.labourParticulars span {
    display: block;
    line-height: 30px;
    margin-left: 16px;
    margin-right: 16px;
    color: #888787;
    font-size: 14px;
}

.labourParticulars .spanClass {
    text-indent: 30px;
}

.labourParticulars_bottomImg {
    width: 15%;
    display: block;
    left: 0;
    right: 0;
    margin: auto;
    position: absolute;
    bottom: 12px;
}

.QRcode {
    width: 30%;
    display: block;
    margin: 10px auto;
}
.QRImgCode-box {
    width: 85%;
    display: block;
    margin: 20px auto;
}
#title-name-id{
    margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Manpower/manpowerParticulars1.vue